
namespace GeniuzPOS.Purchase {
    import fld = ListAppPurInvoiceRow.Fields


    @Serenity.Decorators.registerClass()
    export class ListAppPurInvoiceGrid extends Serenity.EntityGrid<ListAppPurInvoiceRow, any> {
        protected getColumnsKey() { return ListAppPurInvoiceColumns.columnsKey; }
        protected getDialogType() { return ListAppPurInvoiceDialog; }
        protected getIdProperty() { return ListAppPurInvoiceRow.idProperty; }
        protected getInsertPermission() { return ListAppPurInvoiceRow.insertPermission; }
        protected getLocalTextPrefix() { return ListAppPurInvoiceRow.localTextPrefix; }
        protected getService() { return ListAppPurInvoiceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            // let self = this;
            // self.toolbar.findButton('add-button').text('สร้างรายการ');
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }

        protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {

            let filters = super.getQuickFilters();


             

            var userId = Q.first(Administration.UserRow.getLookup().items, x => x.Username == Authorization.userDefinition.Username);
             var userapprole = Q.tryFirst(Administration.UserApprovalRoleRow.getLookup().items, x => x.UserId == userId.UserId);


            Q.first(filters, x => x.field == fld.WaitApprove).init = w => {

                (w as Serenity.StringEditor).value = userapprole.ApprGroupCode ?? "";
               
            };
         

            return filters;
        }
    }
}